import * as Yup from 'yup';

const schema = Yup.object().shape({
  name: Yup.string().required('Nome Obrigatório'),
});

export default schema;
